import SvgIcon from "@mui/material/SvgIcon";

function CustomInfoShieldIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        d="M12 2L3 6v6c0 5.25 3.75 10 9 10s9-4.75 9-10V6l-9-4z"
        fill="none"
        stroke="#00C853"
        strokeWidth="2"
      />
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        dy=".35em"
        fontSize="12"
        fill="#00C853"
      >
        i
      </text>
    </SvgIcon>
  );
}

export default CustomInfoShieldIcon;
